import { $notification, reset } from '../ui/Notification/Notification.tsx'

export function show(text: string, isError = true, duration = 5_000) {
	$notification.set({ status: isError ? 'error' : 'none', text })
	setTimeout(reset, duration)
}
